import { IOfferedSubject, IOfferedSubjectSection } from "../types";
import { extraerNombreMateria, normalizeText } from "./index";

export const filterSubjects = (
  subjects: IOfferedSubject[],
  searchTerm: string,
  titleTranslations: Map<string, string> = new Map(),
): IOfferedSubject[] => {
  const normalizedSearch = normalizeText(searchTerm);
  return subjects
    .map((s: IOfferedSubject) => {
      const filteredSections = s.sections.filter((section) => {
        const originalTitle = section.section ?? "";
        const subjectName = extraerNombreMateria(originalTitle);
        const translatedTitle = titleTranslations.get(subjectName) ?? "";
        const matchesTitle =
          normalizeText(originalTitle).includes(normalizedSearch) ||
          normalizeText(translatedTitle).includes(normalizedSearch);
        const matchesProf = (section.subjectData?.subjectsByType ?? []).some((subject) => {
          return (subject?.subjectInfo ?? []).some((info) => {
            return (info?.values?.profesores ?? []).some((prof) => {
              return normalizeText(prof ?? "").includes(normalizedSearch);
            });
          });
        });
        return matchesTitle || matchesProf;
      });

      return {
        ...s,
        sections: filteredSections,
      };
    })
    .filter((s: IOfferedSubject) => s.sections.length > 0);
};


/**
 * Función utilitaria para filtrar y ordenar las materias ofrecidas
 * @param subjects Lista de materias ofrecidas
 * @param inscribedSubsIds Lista de materias inscritas
 * @param debeFiltrarCursosConCupoNoAsignado Si es true, se excluyen los cursos cuyo idCupo (reserveData.idC) sea -1
 * @returns Lista de secciones de materias ofrecidas filtradas y ordenadas
 */
export const filterAndOrderSubjects = (
  subjects: IOfferedSubject[],
  inscribedSubsIds: { idCurso: number; anioLectivo: number }[],
  debeFiltrarCursosConCupoNoAsignado: boolean = false,
  prioridadHabilitada: boolean
): IOfferedSubjectSection[] => {
  const sectionsList: IOfferedSubjectSection[] = [];
  
  // Validar que subjects sea un array
  if (!Array.isArray(subjects)) {
    return sectionsList;
  }
  
  subjects
    .sort((a: IOfferedSubject, b: IOfferedSubject) => {
      const yearA = Array.isArray(a.sections) && a.sections.length > 0 ? a.sections[0]?.year ?? 0 : 0;
      const yearB = Array.isArray(b.sections) && b.sections.length > 0 ? b.sections[0]?.year ?? 0 : 0;

      return yearA - yearB;
    })
    .forEach((subject) => {
      // Validar que subject.sections sea un array
      if (Array.isArray(subject.sections)) {
        const newSections = subject.sections.filter((section) => {
          const yaInscripta = inscribedSubsIds.some(
            (s) => s.idCurso === section.idCurso && s.anioLectivo === section.anioLectivo
          );
          if (yaInscripta) return false; //filtramos las secciones ya inscriptas
          if (debeFiltrarCursosConCupoNoAsignado && prioridadHabilitada && section.subjectData?.reserveData?.idC === -1) {
            return false; //filtramos los cursos con cupo no asignado (idCupo === -1)
          }
          return true;
        });
        if (newSections.length > 0) {
          sectionsList.push(...newSections);
        }
      }
    });
  const sectionsVisibles = sectionsList.filter((section) => section.visibleEnOferta);
  return sectionsVisibles;
};
